<template>
    <Box :title="'验收记录('+Total+'台)'" :SearchParams="IsSee" @SearchParams="IsSee=true">
        <LoadingFooter v-model="loading" :finished="finished" @load="onLoad" @scroll="IsSee=false">
            <div :class="search.YSBZ==='1'?'items IsLoadMax':'items IsLoad'" v-for="(item, index) in list" @click="pageLoad(item)">
                <div class="itemTopBox">
                    <div>
                        <span>单号</span>
                        <span>{{item.DH}}</span>
                    </div>
                    <div>
                        <span>编号</span>
                        <span>{{item.HTBH}}</span>
                    </div>
                    <div>
                        <span>设备名称</span>
                        <span>{{item.SBMC}}</span>
                    </div>
                    <div>
                        <span>规格型号</span>
                        <span>{{item.SBGG}}</span>
                    </div>
                    <div>
                        <span>数量</span>
                        <span>{{item.SL}}</span>
                    </div>
                    <div>
                        <span>设备单价</span>
                        <span>{{item.CGDJ}}</span>
                    </div>
                    <div>
                        <span>总金额</span>
                        <span>{{item.ZJE}}</span>
                    </div>
                    <div>
                        <span>供应商</span>
                        <span>{{item.GYSMC}}</span>
                    </div>
                    <div>
                        <span>生产厂家</span>
                        <span>{{item.SCQYMC}}</span>
                    </div>
                </div>
                <div class="itemBottomBox">
                    <div v-if="Button" @click.stop="_delete(item,index)">删除</div>
                    <div v-if="Button" @click.stop="search.YSBZ==='1'&&search.SHBZ==='0'?AuditPutInForm(item,index):
                    $router.push({name: 'StorageEquipment', params: {item}})">{{SecondText}}</div>
                    <div>{{ThirdlyText}}</div>
                </div>
            </div>
        </LoadingFooter>
        <transition name="fade">
            <div class="menu" key="0" v-if="IsSee">
                <Field title="合同名称" placeholder="请输入" @onMessage="value => search.HTMC = value" />
                <Field title="供应商" placeholder="请输入供应商编号或名称" @onMessage="value => search.GYSMC = value" />
                <Field title="设备名称" placeholder="请输入设备名称" @onMessage="value => search.SBMC = value" />
                <Field title="开始时间" placeholder="请选择" type="calendar" @onMessage="value => search.StartDate = value" />
                <Field title="结束时间" placeholder="请选择" type="calendar" @onMessage="value => search.EndDate = value" />
                <Field title="入库状态" :tabSelected='search.YSBZ' type="teb" :data="[{id:'0',name:'未入库'},{id:'1',name:'已入库'}]"
                    @onMessage="value =>search.YSBZ = value.id" />
                <Field v-if="search.YSBZ==='1'" title="审核状态" :tabSelected='search.SHBZ' type="teb" :data="[{id:'0',name:'未审核'},{id:'1',name:'已审核'}]"
                    @onMessage="value =>search.SHBZ = value.id" />
                <div class="search" @click="serach">查询</div>
            </div>
        </transition>
    </Box>
</template>

<script>
    import Box from '@/components/commonBox/commonBox'
    import Field from '../../components/field/field'
    import LoadingFooter from '../../components/loadingFooter/loadingFooter'
    export default {
        name: 'History',
        data() {
            return {
                search: {
                    YSBZ: '0',
                    SHBZ: '0',
                    HTMC: '',
                    GYSMC: '',
                    SBMC: '',
                    StartDate: '',
                    EndDate: '',
                },
                list: [],
                AZYS: [],
                loading: false,
                finished: false,
                IsSee: false,
                touchStartY: 0,
                page: 5,
                Total: 0,
                Button: true,
                SecondText: '入库',
                ThirdlyText: '修改',
                AcceptanceInfoList: {},
                pageState: true
            }
        },
        components: {
            Box,
            Field,
            LoadingFooter,
        },
        activated() {

            this.loadDataDefault();
        },
        methods: {
            serach() {
                this.IsSee=false;
                this.pageState=true;
                this.page = 5;
                this.loading = false;
                this.finished = false;
                this.Button = this.search.YSBZ === '1' && this.search.SHBZ === '1' ? false : true;
                this.SecondText = this.search.YSBZ === '1' && this.search.SHBZ === '0' ? '审核' : '入库';
                this.ThirdlyText = this.search.YSBZ === '1' && this.search.SHBZ === '1' ? '详情' : '修改';
                this.loadDataDefault();
            },
            onLoad() {
                if (this.pageState) {
                    this.page += 5;
                    this.loadDataDefault();
                }
            },
            _delete(item, index) {
                this.$Dialog.confirm({
                    message: '确定删除？'
                }).then(() => {
                    this.$get('api/CheckIncoming/DelPutInForm', {
                        Token: '',
                        DH: item.DH,
                        SBBH: item.SBMCBH,
                        HTBH: item.HTBH,
                        HTID: item.HTId
                    }).then(result => {
                        if (result.Status) {
                            this.$Toast("删除成功!");
                            this.list.splice(index, 1)
                        } else this.$Toast(result.Msg);
                    })
                }).catch(() => {});
            },
            onScroll(value) {
                if (value > this.touchStartY) {
                    this.touchStartY = value;
                    this.IsSee = false;
                } else if ((this.touchStartY - value) > 20) {
                    this.touchStartY = value
                    this.IsSee = true;
                }
            },
            loadDataDefault() { //列表获取
                this.$post('api/CheckIncoming/PutInOrAuditList', {
                    PageIndex: 1,
                    PageSize: this.page,
                    StartDate: this.search.StartDate,
                    EndDate: this.search.EndDate,
                    HTMC: this.search.HTMC,
                    GYSMC: this.search.GYSMC,
                    SBMC: this.search.SBMC,
                    YSBZ: this.search.YSBZ,
                    SHBZ: this.search.YSBZ === '0' ? '0' : this.search.SHBZ,
                    Store: this.$UserInfo.StoreCode,
                    Token: '123456789'
                }).then(result => {
                    this.Total = result.Total;
                    this.list = result.PutInOrAuditList;
                    if (this.page >= this.Total) {
                        this.loading = false;
                        this.finished = true;
                        this.pageState = false;
                    }

                })
            },
            AuditPutInForm(item, index) { //验收入库审核
                this.$Dialog.confirm({
                    message: `确定审核单号【${item.DH}】?`
                }).then(() => {
                    this.$get('api/CheckIncoming/AuditPutInForm', {
                        Token: '123456',
                        DH: item.DH,
                        SBBH: item.SBMCBH
                    }).then(result => {
                        if (result.Status) {
                            this.$Toast({
                                message:'审核成功!',
                                duration:1500,
                                onClose:()=>{
                                    this.loadDataDefault();
                                }
                            });
                        } else this.$Toast(result.Msg);
                    })
                }).catch(() => {});
            },
            pageLoad(item) { //修改或者查看详情
                this.$get('api/CheckIncoming/LoadPutInInfo', {
                    Token: 'YTDF5EF3A6174564E5981A446158F106',
                    DH: item.DH,
                    SBBH: item.SBMCBH,
                }).then(result => {
                    let requestData = result.PutInInfoList[0];
                    this.AcceptanceInfoList = result.PutInInfoList[0];
                    this.AcceptanceInfoList.LSBH = this.$UserInfo.UserId + this.$format(new Date(),
                        'YYYYMMDDHHmmss');
                    this.AcceptanceInfoList.ZJE=item.ZJE;//api未返回zje字段，取列表出字段zje
                    this.$router.push({
                        name: 'EquipmentAcceptanceDetails',
                        params: {
                            AcceptanceInfoList: this.AcceptanceInfoList,
                            AZYS: (result.PutInInfoList[0].AZYSQK||'').split(','), //安装验收复选框
                            IsAddOrUpdata: true,
                            PageState: this.ThirdlyText === '详情' ? true : false,
                        }
                    })
                })
            }
        }
    }
</script>

<style scoped lang="scss">
    .menu {
        background: $BACKGROUND-COLOR;
        border-radius: 12px;
        padding: 0 29px 35px 40px;
        box-sizing: border-box;
        margin-bottom: 20px;

        .items {
            display: flex;
            height: 112px;
            align-items: center;
            border-bottom: 2px solid #F3F3F3;

            span {
                flex: 1;
            }

            input {
                width: 215px;
                font-size: 29px;
                text-align: center;

                &::-webkit-input-placeholder {
                    color: #858585;
                }
            }
        }

        .search {
            height: 88px;
            background: $THEME-COLOR;
            border-radius: 8px;
            font-size: 32px;
            color: $TEXT-LIGHT-COLOR;
            text-align: center;
            line-height: 88px;
            margin-top: 35px;
        }
    }

    .items {
        background: $BACKGROUND-COLOR;
        border-radius: 16px;
        margin-bottom: 20px;
        padding: 36px 30px;

        .itemTopBox {
            border-bottom: 2px solid #eee;

            div {
                display: flex;
                align-items: center;
                font-size: 28px;
                margin-bottom: 32px;

                span:first-child {
                    flex: 1;
                    color: #858585;
                }

                span:last-child {
                    color: $TEXT-DARK-COLOR;
                    font-weight: bold;
                    width: 326px;
                    text-align: right;
                }
            }
        }

        .itemBottomBox {
            margin-top: 32px;
            display: flex;
            align-items: center;
            justify-content: center;

            div {
                width: 200px;
                height: 80px;
                border-radius: 8px;
                text-align: center;
                line-height: 80px;
                font-size: 26px;
                margin-right: 42px;

                &:first-child {
                    background: #dedede;
                    color: #858585;
                }

                &:nth-child(2) {
                    background: $THEME-COLOR;
                    color: #fff;
                }

                &:last-child {
                    background: $THEME-COLOR;
                    color: #fff;
                    margin-right: 0;
                }
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/page/history/history.vue